import { useScreenshot } from "renderer/hooks/useScreenshot";
import useTakeScreenshot from "../../hooks/useTakeScreenshot";

const Screenshot = () => {
	const { triggerScreenshotEvent } = useTakeScreenshot();
	useScreenshot((x, x2, x3, base64Image) => {
		triggerScreenshotEvent({ base64Image });
	});

	return null;
};

export default Screenshot;
